import React, { useState } from 'react';
import { Dropdown, Checkbox, Button, Space, theme } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { trackEvent } from "../utils/util-functions";

const { useToken } = theme;

const LIBRARIES_DATA = [
  { id: 'IRremote', desc: 'Send and receive infrared signals with multiple protocols' },
  { id: 'Blynk', desc: 'Build an app for your projects and control hardware remotely.' },
  { id: 'MFRC522', desc: 'Library to use ARDUINO RFID-RC522 module.' },
  { id: 'TinyGSM', desc: 'A small Arduino library for GSM modules' },
  { id: 'DHT sensor library', desc: 'Arduino library for DHT11, DHT22, etc Temperature & Humidity Sensors' },
  { id: 'NewPing', desc: 'Ultrasonic sensor (HC-SR04, SRF05, etc.) library for Arduino' },
  { id: 'Servo', desc: 'Allows Arduino boards to control servo motors' },
  { id: 'Stepper', desc: 'Allows Arduino boards to control stepper motors' },
  { id: 'Wire', desc: 'I2C communication library for connecting sensors and modules' },
  { id: 'LiquidCrystal I2C', desc: 'Drive LCD displays over the I2C bus using just 2 wires' }
];

const ArduinoLibrariesLoader = (props) => {
  const [open, setOpen] = useState(false);
  const [checkboxObj, setChecked] = useState(() => {
    const initialState = {};
    LIBRARIES_DATA.forEach(lib => {
      initialState[lib.id] = false;
    });
    return initialState;
  });

  const handleMenuClick = (packageName) => {
    trackEvent("ide_install_package_clicked", {
      ide_project_stack_name: props.ideProjectStackName,
      packageName
    });
    setChecked(prevState => {
      const newState = { ...prevState };
      newState[packageName] = !newState[packageName];
      return newState;
    });
  };

  const handleSubmitPackages = () => {
    const packages = Object.entries(checkboxObj)
      .filter(([_, checked]) => checked)
      .map(([pkg]) => pkg);

    props.submittedLibraries(packages);
    setOpen(false);
  };

  const handleOpenChange = open => {
    if (open) {
      let checkObj = { ...checkboxObj };
      Object.keys(checkObj).forEach(key => {
        if (props.selectedLibrariesList && props.selectedLibrariesList.includes(key)) {
          checkObj[key] = true;
        } else {
          checkObj[key] = false;
        }
        setChecked(checkObj);
      });
    }
    setOpen(open);
  };
  const { token } = useToken();

  const contentStyle = {
    width: '350px',
    controlItemBgActive: '#bae0ff',
    backgroundColor: token.colorBgElevated,
    borderRadius: token.borderRadiusLG,
    boxShadow: token.boxShadowSecondary,
    display: 'flex',
    flexDirection: 'column',
  };

  const menuStyle = {
    boxShadow: 'none',
    maxHeight: '400px',
    overflowY: 'auto',
  };

  const items = LIBRARIES_DATA.map((lib, index) => ({
    key: String(index + 1),
    colorBgElevated: '#232F34',
    label: (
      <div className='row plugin-item' style={{ cursor: 'auto' }}>
        <div className='col-1'>
          <Checkbox
            checked={checkboxObj[lib.id]}
            onChange={() => handleMenuClick(lib.id)}
          ></Checkbox>
        </div>
        <div className='col-1'></div>
        <div className='col-10' style={{ paddingLeft: '20px' }}>
          <span>{lib.id}</span><br />
          <span className='text-muted text-break'>{lib.desc}</span>
          <div className='wrap-addplugin' onClick={() => handleMenuClick(lib.id)}>
            {checkboxObj[lib.id] ? <span>Remove</span> : <span>Add</span>}
          </div>
        </div>
      </div>
    ),
  }));

  return (
    <Dropdown
      menu={{ items }}
      trigger={['click']}
      open={open}
      onOpenChange={handleOpenChange}
      placement="bottomRight"
      dropdownRender={(menu) => (
        <div style={contentStyle}>
          {React.cloneElement(menu, {
            style: menuStyle,
          })}
          <Space
            style={{
              padding: 8,
              alignSelf: 'flex-end',
            }}
          >
            <Button type="primary" onClick={handleSubmitPackages}>Add selected</Button>
          </Space>
        </div>
      )}
    >
      <Button style={{ color: '#404040' }}>
        <PlusOutlined /> Manage Libraries
      </Button>
    </Dropdown>
  );
};

export default ArduinoLibrariesLoader;
